import {Typography} from '@mui/material'
import {messages} from './translations'

export const S2ARedirectComponent = () => {
    return (
        <div>
            <Typography variant="h3">{messages.getText('misc', 'redirectS2aTitle')}</Typography>
            {messages.getText('misc', 'redirectS2aText')}
        </div>
    )
}
